export const Endpoint = () => `/api/v3/admin/toggleban/`;
export const Csrf = () => `/api/v3/admin/token/`;

export interface Payload {
    id: string;
    email: string;
}

export type Response = void;
